import type {
  AccountConfigurationCodeDto,
  AccountConfigurationTypeDto,
  AccountsConfigurationsResponseDto,
} from '../api';

export const sortConfigurationTypes = (
  types: Array<AccountConfigurationTypeDto>
): Array<AccountConfigurationTypeDto> => {
  return [...types].sort((a, b) => {
    if (a.displayOrder !== b.displayOrder) {
      return a.displayOrder - b.displayOrder;
    }
    const aCode = a.accountTypeCode.toLowerCase();
    const bCode = b.accountTypeCode.toLowerCase();
    if (aCode < bCode) return -1;
    if (aCode > bCode) return 1;
    return 0;
  });
};

export const findConfigurationType = (
  configuration: AccountsConfigurationsResponseDto | undefined,
  accountTypeCode: string
): AccountConfigurationTypeDto | undefined => {
  return configuration?.accountTypes.find(
    type => type.accountTypeCode.toLowerCase() === accountTypeCode.toLowerCase()
  );
};

export const findConfigurationCode = (
  type: AccountConfigurationTypeDto | undefined,
  accountCode: string
): AccountConfigurationCodeDto | undefined => {
  return type?.accountCodes.find(
    code => code.accountCode.toLowerCase() === accountCode.toLowerCase()
  );
};

export const hasEula = (
  configuration: AccountsConfigurationsResponseDto | undefined
): boolean => {
  return !!configuration?.eula && configuration.eula.trim() !== '';
};
